import { render, staticRenderFns } from "./OverviewChart.vue?vue&type=template&id=80c5bd38"
import script from "./OverviewChart.vue?vue&type=script&lang=ts"
export * from "./OverviewChart.vue?vue&type=script&lang=ts"
import style0 from "./OverviewChart.vue?vue&type=style&index=0&id=80c5bd38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports